import { Injectable, Injector } from "@angular/core";
import { RespuestaEncuesta, RespuestaUsuario } from "@DTOS";
import { CacheRespuestas } from "../CacheRespuestas";
import { ProcesoDatos } from "../../../../proceso-datos/ProcesoDatos";

@Injectable()
export class PasoCargaCache {
    constructor(private cacheRespuestasService: CacheRespuestas, private injector: Injector) {}

    public cargarDesde(respuestas: RespuestaEncuesta[]): RespuestaUsuario[] {
        const procesoDatos = this.obtenerProcesoDatos();
        procesoDatos.procesar(respuestas);
        this.cacheRespuestasService.guardarDesdeProcesoDatos(procesoDatos);
        return procesoDatos.respuestasEnCrudo;
    }

    public procesarDesde(respuestas: RespuestaUsuario[]): RespuestaUsuario[] {
        const procesoDatos = this.obtenerProcesoDatos();
        procesoDatos.procesarDesde(respuestas);
        this.cacheRespuestasService.guardarDesdeProcesoDatos(procesoDatos);
        return procesoDatos.respuestasEnCrudo;
    }

    private obtenerProcesoDatos(): ProcesoDatos {
        const procesoDatos = this.injector.get(ProcesoDatos);
        procesoDatos.cargarDatos();
        return procesoDatos;
    }
}
